import RouteContainer from 'containers/RouteContainer';
import Component from './containers/BackgroundContainer';

export const route = `${DOCUMENTS_PATH}/background`;
export const navigation = { name: 'background', id: 'background.title', editTitle: 'dictionary.edit' };
export const navMsBackground = { name: 'msBackground', id: 'background.title', nonNavigable: true };

export default RouteContainer(route, Component);
